export const LOCAL_LAYOUT_EDITOR_EVENT = 'formica:open-local-layout-editor';

export type LocalLayoutEditorRequestDetail = {
  source: 'command-palette' | 'unknown';
};

export function requestLocalLayoutEditor(
  detail: LocalLayoutEditorRequestDetail = { source: 'unknown' }
): boolean {
  const event = new CustomEvent<LocalLayoutEditorRequestDetail>(LOCAL_LAYOUT_EDITOR_EVENT, {
    cancelable: true,
    detail,
  });
  return !window.dispatchEvent(event);
}
